var _a;
import { getModalStyles } from 'wix-rich-content-editor-common';
import { ButtonType } from 'wix-rich-content-common';
import { Modals } from '../modals';
import linkModalConfig from './link-modal.config';
import { PluginToolbarButtons } from '../../../enums';
import { Edit } from '../../../components/icons';
var defaultButtons = [
    PluginToolbarButtons.BEST_FIT,
    PluginToolbarButtons.FULL_WIDTH,
    PluginToolbarButtons.ALIGN_LEFT,
    PluginToolbarButtons.ALIGN_RIGHT,
    PluginToolbarButtons.SEPARATOR,
    PluginToolbarButtons.REPLACE,
    PluginToolbarButtons.DELETE,
];
var configurableButtons = (_a = {},
    _a[PluginToolbarButtons.BEST_FIT] = {
        keyName: 'sizeContent',
        type: ButtonType.SIZE_CONTENT,
        mobile: false,
    },
    _a[PluginToolbarButtons.FULL_WIDTH] = {
        keyName: 'sizeFullWidth',
        type: ButtonType.SIZE_FULL_WIDTH,
        mobile: false,
    },
    _a[PluginToolbarButtons.ALIGN_LEFT] = {
        keyName: 'sizeSmallLeft',
        type: ButtonType.SIZE_SMALL_LEFT,
        mobile: false,
    },
    _a[PluginToolbarButtons.ALIGN_RIGHT] = {
        keyName: 'sizeSimallRight',
        type: ButtonType.SIZE_SMALL_RIGHT,
        mobile: false,
    },
    _a[PluginToolbarButtons.SEPARATOR] = {
        keyName: 'separator',
        type: ButtonType.SEPARATOR,
        mobile: false,
    },
    _a[PluginToolbarButtons.REPLACE] = {
        keyName: 'replace',
        icon: Edit,
        type: ButtonType.EXTERNAL_MODAL,
        modalName: Modals.VIDEO_LINK,
        componentData: linkModalConfig,
        modalStyles: getModalStyles({ fullScreen: false }),
        mobile: true,
        tooltipTextKey: 'ReplaceVideoButton_Tooltip',
    },
    _a[PluginToolbarButtons.DELETE] = {
        keyName: 'delete',
        type: ButtonType.DELETE,
        mobile: true,
    },
    _a);
export default (function (_a) {
    var pluginConfig = _a.pluginConfig, helpers = _a.helpers;
    var buttons = pluginConfig.toolbarButtons || defaultButtons;
    // If we only have one button toggle remove it
    var hasFullWidth = buttons.find(function (b) { return b === PluginToolbarButtons.FULL_WIDTH; }) !== undefined;
    var hasBestFit = buttons.find(function (b) { return b === PluginToolbarButtons.BEST_FIT; }) !== undefined;
    var hasLeftRightAlign = buttons.find(function (b) {
        return b === PluginToolbarButtons.ALIGN_LEFT ||
            b === PluginToolbarButtons.ALIGN_RIGHT;
    });
    var remove = {};
    if (hasFullWidth && !hasBestFit && !hasLeftRightAlign) {
        remove[PluginToolbarButtons.FULL_WIDTH] = true;
        hasFullWidth = false;
    }
    if (!hasFullWidth && hasBestFit && !hasLeftRightAlign) {
        remove[PluginToolbarButtons.BEST_FIT] = true;
    }
    return buttons
        .filter(function (button) { return !!configurableButtons[button]; })
        .filter(function (button) { return (remove[button] ? false : true); })
        .filter(function (button, idx) {
        return idx === 0 && button === PluginToolbarButtons.SEPARATOR ? false : true;
    })
        .map(function (button) { return configurableButtons[button]; });
});
//# sourceMappingURL=inline-buttons.js.map